import React, {useEffect, useMemo, useRef, useState} from 'react'
import {useHistory, useParams} from 'react-router-dom'
import {useDispatch} from 'react-redux'
import {useDropzone} from "react-dropzone"
// import Select2 from "react-select2-wrapper";
import axios from 'axios'
import Cookies from 'js-cookie'
import moment from 'moment'

import actions from 'actions'
import {
  API_CORE_URL,
  API_URL,
  formatDate,
  paymentIntervals,
  UK_VEHICLE_DATA_API_KEY,
  UK_VEHICLE_DATA_API_URL
} from 'constants/index.js'

import CardsHeader from 'layouts/Headers/CardsHeader.js'
import InputCustom from 'views/pages/components/InputCustom'
import {InputArraySelect, InputKeySelect,} from 'views/pages/components/InputSelect'
import TableCustom from 'views/pages/components/TableCustom'
import VerticalLabel from 'views/pages/components/VerticalLabel'

import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Carousel,
  CarouselControl,
  CarouselItem,
  Col,
  Container,
  FormGroup,
  Input,
  Modal,
  Row,
  Table,
} from 'reactstrap'
import {ButtonContainer, Line, LoaderContainer, override} from "@pages/reusable-components/styled-components";
import {ClipLoader} from "react-spinners";
import IcoMoon from "react-icomoon";
import IconSet from "@assets/selection.json";
import notify from "@utils/notify";
import VehicleDetails from "@pages/vehicles/vehicle-edit-components/VehicleDetails.tsx";
import VehicleFinancial from "@pages/vehicles/vehicle-edit-components/VehicleFinancial.tsx";
import VehicleFrontEnd from "@pages/vehicles/vehicle-edit-components/VehicleFrontEnd.tsx";
import VehicleDocuments from "@pages/vehicles/vehicle-edit-components/VehicleDocuments.tsx";
import VehicleTasksComponent from "@pages/vehicles/vehicle-edit-components/VehicleTasks.tsx";

const baseStyle = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: "20px",
  borderWidth: 2,
  borderRadius: 2,
  borderColor: "#eeeeee",
  borderStyle: "dashed",
  backgroundColor: "#fafafa",
  color: "#bdbdbd",
  outline: "none",
  transition: "border .24s ease-in-out"
}

const activeStyle = {
  borderColor: "#2196f3"
}

const acceptStyle = {
  borderColor: "#00e676"
}

const rejectStyle = {
  borderColor: "#ff1744"
}

export default function VehicleEdit() {
  const { id } = useParams()
  const history = useHistory()
  const dispatch = useDispatch()
  const [tab, setTab] = useState('details')
  const [token, setToken] = useState('')
  const [delay, setDelay] = useState(false)
  const [vehicle, setVehicle] = useState('');
  const [makes, setMakes] = useState([])
  const [models, setModels] = useState([])
  const [filteredModels, setFilteredModels] = useState([])
  const [fundingStyles, setFundingStyles] = useState([])
  const [vehicleRepository] = useState('')
  const [settlementCost, setSettlementCost] = useState('')

  const [animating, setAnimating] = useState(false)

  const [slides, setSlides] = useState('')

  const [errors, setErrors] = useState('')
  const [soldErrors, setSoldErrors] = useState('')
  const [loading, setLoading] = useState(true)

  useEffect(() => {

    const getFoundingStyles = () => {
      return axios({
        method: 'GET',
        url: `${API_URL}/funding-styles`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }).then(res => {
        return res.data
      }).catch(err => {
        return err
      })
    }
     if (tab === 'financial') {
      if (fundingStyles.length === 0) {
        getFoundingStyles().then(res => {
          setFundingStyles(res)
        })
      }
    }
  }, [tab])


  useEffect(() => {
    const grs_token = Cookies.get('grs_token')
    setToken(grs_token)

    const source = axios.CancelToken.source()

    const fetchData = async () => {

      try {
        setLoading(true)
        const response = await axios({
          method: 'GET',
          url: `${API_URL}/vehicle/${id}`,
          headers: {
            Authorization: `Bearer ${grs_token}`,
          },
          cancelToken: source.token,
        })
        const administrativeRes = await axios({
          method: 'GET',
          url: `${API_URL}/vehicle/${id}/administrative`,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        const data = response.data
        setVehicle({
          ...data.data,
          features: data.data.features,
          administrative: administrativeRes.data.data.administrative,
          vehicle_division: 0
        })
        const makesRequest = await axios({
          method: 'GET',
          url: `${API_CORE_URL}/vehicle-make`,
          headers: {
            Authorization: `Bearer ${grs_token}`,
          },
          cancelToken: source.token,
        })
        const modelsRequest = await axios({
          method: 'GET',
          url: `${API_CORE_URL}/vehicle-model`,
          headers: {
            Authorization: `Bearer ${grs_token}`,
          },
          cancelToken: source.token,
        })
        setMakes(makesRequest.data.data)
        setModels(modelsRequest.data.data)
        setFilteredModels(modelsRequest)

        setSettlementCost(administrativeRes.data.settlementCost)

        let _images = data.data?.vehicleImages?.images_collection || []
        const slides = _images.map((item) => {
          return (
            <CarouselItem
              onExiting={() => setAnimating(true)}
              onExited={() => setAnimating(false)}
              key={item.link}
            >
              <img alt={''} src={`${item.link}`} width={900} height={405} />
            </CarouselItem>
          )
        })
        setSlides(slides)

        setTimeout(() => {
          setDelay(true)
        }, 500)
        setLoading(false)
        dispatch(actions.getNotifications(grs_token))
      } catch (error) {
        setLoading(false)
        setDelay(true)
        if (axios.isCancel(error)) {
          console.log('Request canceled :: ', error)
        } else {
          console.error('error :: ', error)
          notify.warning(error.response && error.response.data ? error.response.data.message : error.response ? error.response.statusText : 'Error Occurred!')
        }
      }
    }

    fetchData()

    return () => {
      source.cancel()
    }
  }, [])
  const updateVehicle = (tempVehicle, callback = null) => {
    setVehicle({...tempVehicle})
    delete tempVehicle['vehicleGear']
    delete tempVehicle['vehicle_gear']
    delete tempVehicle['vehicleFuel']
    delete tempVehicle['vehicle_fuel']
    delete tempVehicle['vehicleMake']
    delete tempVehicle['vehicle_make']
    delete tempVehicle['vehicleModel']
    delete tempVehicle['vehicle_model']
    delete tempVehicle['document_files']
    delete tempVehicle['documents']
    delete tempVehicle['tasks']

    let formData = new FormData()

    if (tempVehicle.images_collection && tempVehicle.images_collection.length > 0) {
      for (let index = 0; index < tempVehicle.images_collection.length; index++) {
        const element = tempVehicle.images_collection[index]
        if (typeof element == 'object' && element.type) {
          formData.append(`images_collection[${index}]`, element)
        }
      }
    }

    Object.keys(tempVehicle).forEach(key => {
      if (key !== 'images_collection' && key !== 'ownerable' && ![null, undefined].includes(tempVehicle[key])) {
        if (key === 'featured_image') {
          if (typeof tempVehicle[key] == 'object') {
            formData.append(key, tempVehicle[key])
          }
        } else if (key === 'administrative') {
          Object.keys(tempVehicle[key]).forEach(_key => {
            if (_key === 'mot_date' || _key === 'rfl_taxed_date' || _key === 'valuation_time') {
              formData.append(`administrative[${_key}]`, tempVehicle[key][_key] ? moment(tempVehicle[key][_key], 'DD/MM/YYYY').format('YYYY-MM-DD') : '');
            }
          })
        } else {
          if (key === 'tracker' || key === 'enabled') {
            if (tempVehicle[key] !== 0 && tempVehicle[key] !== false) {
              formData.append(key, tempVehicle[key])
            }
          } else if (key === 'maintenance_included') {
            formData.append(key, (tempVehicle[key] === true || tempVehicle[key] === 1) ? 1 : 0)
          } else {
            formData.append(key, tempVehicle[key])
          }
        }
      }
    })
    formData.append('vehicle_make_selector', tempVehicle && tempVehicle.vehicle_make_selector ? tempVehicle.vehicle_make_selector : tempVehicle.redundant_vehicle_make_id)
    formData.append('_method', 'PUT')

    axios({
      method: 'PUT',
      url: `${API_URL}/vehicle/${id}`,
      headers: {
        Authorization: `Bearer ${token}`
      },
      data: tempVehicle,
    })
      .then(response => {
        setErrors('')
        setDelay(false)
        console.log('response :: ', response.data)

        notify.success('Vehicle updated successfully.')

        if (callback) callback()

      })
      .catch(error => {
        setErrors('')
        setDelay(true)
        console.error('error :: ', error)
        if (error.response && error.response.status === 422) {
          setErrors(error.response.data.errors)
        }
        notify.warning(error.response ? error.response.statusText : 'Error occurred!')
        if (callback) callback()

      })
  }

  const financialDetails = () => {
    history.push({
      pathname: `/admin/vehicle/${id}/financial`,
    })
  }

  const updateVehicleAdministrative = (vehicleUpdate,settlementConstUpdate = null,callback = null) => {
    axios({
      method: 'POST',
      url: `${API_URL}/vehicle/${id}/administrative`,
      data: {
        ...vehicleUpdate.administrative,
        settlement_cost: settlementConstUpdate?.settlementCost || settlementCost?.settlementCost,
      }
    }).then(() => {
      if (callback) callback()
      notify.success('Success')
    }).catch(error => {
      notify.error('Error while updating vehicle')
      if (callback) callback()
    })
  }
  const sold = (data) => {
    axios({
      method: 'POST',
      url: `${API_URL}/vehicle/${id}/action/sold`,
      data: data,
    })
      .then(response => {
        setSoldErrors('')
        console.log('response :: ', response.data)
        const data = response.data
        notify.success(data.message)
      })
      .catch(error => {
        setSoldErrors('')
        console.error('error :: ', error)
        if (error.response && error.response.status === 422) {
          setSoldErrors(error.response.data.errors)
        }
        notify.warning(error.response ? error.response.statusText : 'Error occurred!')
      })
  }
  const getValuation = () => {
    axios({
      method: 'GET',
      url: `${UK_VEHICLE_DATA_API_URL}/ValuationData?v=2&api_nullitems=1&auth_apikey=${UK_VEHICLE_DATA_API_KEY}&key_VRM=${vehicle.stock_no}`,
    })
      .then(response => {
        const _valuation_data = response.data

        if (_valuation_data.Response) {

          if (_valuation_data.Response.StatusCode === 'Success') {
            const valuationList = _valuation_data.Response.DataItems
            setVehicle(prevVehicle => ({
              ...prevVehicle,
              administrative: {
                ...prevVehicle.administrative,
                dealer_forecourt: valuationList.ValuationList.DealerForecourt ? valuationList.ValuationList.DealerForecourt : 0,
                part_exchange: valuationList.ValuationList.PartExchange ? valuationList.ValuationList.PartExchange : 0,
                trade_poor: valuationList.ValuationList.TradePoor ? valuationList.ValuationList.TradePoor : 0,
                trade_retail: valuationList.ValuationList.TradeRetail ? valuationList.ValuationList.TradeRetail : 0,
                trade_average: valuationList.ValuationList.TradeAverage ? valuationList.ValuationList.TradeAverage : 0,
                auction: valuationList.ValuationList.Auction ? valuationList.ValuationList.Auction : 0,
                valuation_time: valuationList.ValuationTime ? valuationList.ValuationTime : ''
              },
            }))

            notify.success('Got valuation data successfully, please click Save button if you need to save them')
          } else {
            notify.warning(_valuation_data.Response.StatusMessage)
          }
        }
      })
      .catch(error => {
        console.error(error)
      })
  }

  const getVehicleData = () => {
    /**
     * Get vehicle data
     */
    const _vehicle_data_request = axios({
      method: 'GET',
      url: `${UK_VEHICLE_DATA_API_URL}/VehicleData?v=2&api_nullitems=1&auth_apikey=${UK_VEHICLE_DATA_API_KEY}&key_VRM=${vehicle.stock_no}`,
    })

    /**
     * Get vehicle valuation data
     */
    const _mot_tax_data_request = axios({
      method: 'GET',
      url: `${UK_VEHICLE_DATA_API_URL}/MotHistoryAndTaxStatusData?v=2&api_nullitems=1&auth_apikey=${UK_VEHICLE_DATA_API_KEY}&key_VRM=${vehicle.stock_no}`,
    })

    axios.all([_vehicle_data_request, _mot_tax_data_request])
      .then(axios.spread((...responses) => {

        const _vehicle_data = responses[0].data
        const _mot_tax_data = responses[1].data

        if (_vehicle_data.Response && _mot_tax_data.Response) {

          if (_vehicle_data.Response.StatusCode === 'Success') {

            const dataItems = _vehicle_data.Response.DataItems
            const motTaxData = _mot_tax_data.Response.StatusCode === 'Success' ? _mot_tax_data.Response.DataItems.VehicleStatus : []
            setVehicle(prevVehicle =>
            ({
              ...prevVehicle,
              features: {
                ...prevVehicle.features,
                full_vin: dataItems.VehicleRegistration.Vin ? dataItems.VehicleRegistration.Vin : '',
                engine_number: dataItems.VehicleRegistration.EngineNumber ? dataItems.VehicleRegistration.EngineNumber : '',
                first_registered: dataItems.VehicleRegistration.DateFirstRegistered ? dataItems.VehicleRegistration.DateFirstRegistered : '',
                first_registered_uk: dataItems.VehicleRegistration.DateFirstRegisteredUk ? dataItems.VehicleRegistration.DateFirstRegisteredUk : '',
                year_manufacture: dataItems.VehicleRegistration.YearOfManufacture ? dataItems.VehicleRegistration.YearOfManufacture : '',
                gearbox_type: dataItems.VehicleRegistration.Transmission ? dataItems.VehicleRegistration.Transmission : '',
                colour: dataItems.VehicleRegistration.Colour ? dataItems.VehicleRegistration.Colour : '',
                gears_number: dataItems.SmmtDetails.NumberOfGears ? dataItems.SmmtDetails.NumberOfGears : 0,
                fuel_type: dataItems.VehicleRegistration.FuelType,
                engine_capacity: dataItems.VehicleRegistration.EngineCapacity,
                door_plan: dataItems.VehicleRegistration.DoorPlanLiteral,
                seating_capacity: dataItems.VehicleRegistration.SeatingCapacity ? dataItems.VehicleRegistration.SeatingCapacity : 0,
                co2: dataItems.VehicleRegistration.Co2Emissions ? dataItems.VehicleRegistration.Co2Emissions : 0,
                kerb_weight: dataItems.TechnicalDetails.Dimensions.KerbWeight ? dataItems.TechnicalDetails.Dimensions.KerbWeight : 0,
                vin_last_5: dataItems.VehicleRegistration.VinLast5 ? dataItems.VehicleRegistration.VinLast5 : 0,
                scrapped: dataItems.VehicleRegistration.Scrapped,
                date_scrapped: dataItems.VehicleRegistration.DateScrapped,
                exported: dataItems.VehicleRegistration.Exported,
                date_exported: dataItems.VehicleRegistration.DateExported,
                imported: dataItems.VehicleRegistration.Imported,
                imported_non_eu: dataItems.VehicleRegistration.ImportNonEu,
                euro_status: dataItems.TechnicalDetails.General.EuroStatus ? dataItems.TechnicalDetails.General.EuroStatus : '',
                driven_axle: dataItems.TechnicalDetails.General.DrivingAxle ? dataItems.TechnicalDetails.General.DrivingAxle : '',
                type_approval: dataItems.TechnicalDetails.General.TypeApprovalCategory ? dataItems.TechnicalDetails.General.TypeApprovalCategory : '',
                vehicle_class: dataItems.VehicleRegistration.VehicleClass,
                gross_weight: dataItems.TechnicalDetails.Dimensions.GrossVehicleWeight ? dataItems.TechnicalDetails.Dimensions.GrossVehicleWeight : 0,
                length: dataItems.TechnicalDetails.Dimensions.CarLength ? dataItems.TechnicalDetails.Dimensions.CarLength : 0,
                height: dataItems.TechnicalDetails.Dimensions.Height ? dataItems.TechnicalDetails.Dimensions.Height : 0,
                width: dataItems.TechnicalDetails.Dimensions.Width ? dataItems.TechnicalDetails.Dimensions.Width : 0,
                power_bhp: dataItems.TechnicalDetails.Performance.Power.Bhp ? dataItems.TechnicalDetails.Performance.Power.Bhp : 0,
                power_kw: dataItems.TechnicalDetails.Performance.Power.Kw ? dataItems.TechnicalDetails.Performance.Power.Kw : 0,
                power_rpm: dataItems.TechnicalDetails.Performance.Power.Rpm ? dataItems.TechnicalDetails.Performance.Power.Rpm : 0,
                torque_ftlb: dataItems.TechnicalDetails.Performance.Torque.FtLb ? dataItems.TechnicalDetails.Performance.Torque.FtLb : 0,
                torque_nm: dataItems.TechnicalDetails.Performance.Torque.Nm ? dataItems.TechnicalDetails.Performance.Torque.Nm : 0,
                torque_rpm: dataItems.TechnicalDetails.Performance.Torque.Rpm ? dataItems.TechnicalDetails.Performance.Torque.Rpm : 0,
                max_speed_mph: dataItems.TechnicalDetails.Performance.MaxSpeed.Mph ? dataItems.TechnicalDetails.Performance.MaxSpeed.Mph : 0,
                max_speed_kph: dataItems.TechnicalDetails.Performance.MaxSpeed.Kph ? dataItems.TechnicalDetails.Performance.MaxSpeed.Kph : 0,
                cylinders: dataItems.TechnicalDetails.General.Engine.NumberOfCylinders ? dataItems.TechnicalDetails.General.Engine.NumberOfCylinders : 0,
                valves_per_cyl: dataItems.TechnicalDetails.General.Engine.ValvesPerCylinder ? dataItems.TechnicalDetails.General.Engine.ValvesPerCylinder : 0,
                stroke: dataItems.TechnicalDetails.General.Engine.Stroke ? dataItems.TechnicalDetails.General.Engine.Stroke : '',
                bore: dataItems.TechnicalDetails.General.Engine.Bore ? dataItems.TechnicalDetails.General.Engine.Bore : '',
                arrangement: dataItems.TechnicalDetails.General.Engine.CylinderArrangement ? dataItems.TechnicalDetails.General.Engine.CylinderArrangement : '',
                cam_type: dataItems.TechnicalDetails.General.Engine.ValveGear ? dataItems.TechnicalDetails.General.Engine.ValveGear : '',
                engine_location: dataItems.TechnicalDetails.General.Engine.Location ? dataItems.TechnicalDetails.General.Engine.Location : '',
                aspiration: dataItems.TechnicalDetails.General.Engine.Aspiration ? dataItems.TechnicalDetails.General.Engine.Aspiration : '',
                total_keepers: dataItems.VehicleHistory.NumberOfPreviousKeepers ? Number(dataItems.VehicleHistory.NumberOfPreviousKeepers) + 1 : 0,
                colour_changes: dataItems.VehicleHistory.ColourChangeCount ? dataItems.VehicleHistory.ColourChangeCount : 0,
                v5_certificates: dataItems.VehicleHistory.V5CCertificateCount ? dataItems.VehicleHistory.V5CCertificateCount : 0,
              },
              administrative: {
                ...prevVehicle.administrative,
                mot_date: motTaxData.NextMotDueDate ? moment(motTaxData.NextMotDueDate, "DD/MM/YYYY").format("YYYY-MM-DDTHH:mm:ss.SSSSSSZ") : null,
                rfl_taxed_date: motTaxData.MotVed?.VedExpiryDate ? moment(motTaxData.MotVed.VedExpiryDate).format("YYYY-MM-DDTHH:mm:ss.SSSSSSZ") : null,
              },
              vehicleGear: {
                name: dataItems.VehicleRegistration.Transmission
              },
              vehicleFuel: {
                name: dataItems.VehicleRegistration.FuelType
              }
            })
            )
            //
            notify.success('Got vehicle data successfully, please click below Save button if you need to save them');
          } else {
            notify.warning(_vehicle_data.Response.StatusMessage)
          }
        }
      }))
      .catch(error => {
        console.error('error :: ', error)
      })
  }

  const selectMake = (makeId) => {
    let _models = []
    if (makeId === null) {
      setFilteredModels(models)
      return
    }
    if (models.length > 0) {
      _models = models.filter((model) => {
        if (model.vehicle_make_id === parseInt(makeId)) {
          return model
        }
      })

      setFilteredModels(_models)
    }
  }

  return (
    loading ? <LoaderContainer>
      <ClipLoader
        css={override}
        size={40}
        color={`#7B61E4`}
        loading={loading}
      />
    </LoaderContainer> :
      <>
        <CardsHeader name="Vehicle" backButtonText={'Back to Vehicles'} showBackButton={true} parentName="Vehicle Management" redirect={() => history.push(`/admin/vehicle`,)} currentName="List" />

        <Container className="mt--5 admin-main-body" fluid >
          <Card>
            <CardHeader>
              <Row>
                <div className={'navbar-nav cursor-pointer flex-column mr-2'}>
                  <span
                    style={{ color: tab === 'details' && '#ec6409', margin: 5 }}
                    onClick={() => setTab('details')}>
                    Vehicle Details
                  </span>
                  {tab === 'details' &&
                    <Line color={'#ec6409'} />
                  }
                </div>
                <div className={'navbar-nav cursor-pointer flex-column mr-2'}>
                  <span
                    style={{ color: tab === 'financial' && '#ec6409', margin: 5 }}
                    onClick={() => setTab('financial')}>
                    Financial
                  </span>
                  {tab === 'financial' &&
                    <Line color={'#ec6409'} />
                  }
                </div>
                <div className={'navbar-nav cursor-pointer flex-column mr-2'}>
                  <span
                    style={{ color: tab === 'frontend' && '#ec6409', margin: 5 }}
                    onClick={() => setTab('frontend')}>
                    Front End
                  </span>
                  {tab === 'frontend' &&
                    <Line color={'#ec6409'} />
                  }
                </div>
                <div className={'navbar-nav cursor-pointer flex-column mr-2'}>
                  <span
                    style={{ color: tab === 'documents' && '#ec6409', margin: 5 }}
                    onClick={() => setTab('documents')}>
                    Documents
                  </span>
                  {tab === 'documents' &&
                    <Line color={'#ec6409'} />
                  }
                </div>
                <div className={'navbar-nav cursor-pointer flex-column mr-2'}>
                  <span
                    style={{ color: tab === 'tasks' && '#ec6409', margin: 5 }}
                    onClick={() => setTab('tasks')}>
                    Tasks
                  </span>
                  {tab === 'tasks' &&
                    <Line color={'#ec6409'} />
                  }
                </div>
              </Row>
            </CardHeader>
            {tab === 'details' &&
                <VehicleDetails getVehicleData={getVehicleData}
                                initialVehicle={vehicle}
                                makes={makes}
                                updateVehicle={updateVehicle}
                                selectMake={selectMake} filteredModels={filteredModels}/>
            }
            {tab === 'financial' &&
                <VehicleFinancial
                    errors={errors}
                    initialVehicle={vehicle}
                    delay={delay}
                    updateVehicleAdministrative={updateVehicleAdministrative}
                    financialDetails={financialDetails}
                    fundingStyles={fundingStyles}
                    getValuation={getValuation}
                    sold={sold}
                    vehicleRepository={vehicleRepository}
                    settlementCostInitial={settlementCost}
                    soldErrors={soldErrors}
                />
            }

            {tab === 'frontend' &&
                <VehicleFrontEnd initialVehicle={vehicle}
                                 id={id} errors={errors}
                                 initialSlides={slides}
                                 delay={delay}
                                 paymentIntervals={paymentIntervals}
                                 updateVehicleAdministrative={updateVehicleAdministrative}
                />
            }
            {tab === 'documents' &&
                <VehicleDocuments id={id} vehicleInitial={vehicle}  />
            }
            {tab === 'tasks' &&
                <VehicleTasksComponent initialVehicle={vehicle}/>
            }
          </Card>
        </Container>
      </>
  )
}